import React, { useState } from "react";
import Moment from "react-moment";
import { Badge } from "reactstrap";
import StageDetailsModal from "./StageDetailsModal";

const StageTimeline = ({
                         postulationState,
                         postulatedAt,
                         stages,
                         workFlow = []
                       }) => {
  const [openStage, setOpenStage] = useState(null);

  const orderedStages = Array.isArray(stages)
    ? workFlow
      .map(step => stages.find(s => s.stage_type === step.type))
      .filter(Boolean)
    : [];

  const countUploadedDocs = (stage) => {
    if (!stage || !Array.isArray(stage.requested_documents)) return 0;
    return stage.requested_documents.filter(d => d?.uploaded).length;
  };

  const DocsIcon = ({ stage }) => {
    const uploaded = countUploadedDocs(stage);
    if (uploaded <= 0) return null;
    const title = uploaded === 1 ? "1 documento adjunto" : `${uploaded} documentos adjuntos`;
    return (
      <span className="ms-1" title={title} aria-label={title}>
        <i className="fas fa-paperclip text-secondary" aria-hidden="true"></i>
      </span>
    );
  };


  const icon = state => {
    const cfg = {
      pending:  ["far fa-clock text-white", "warning",  "Pendiente"],
      approved: ["fas fa-check",            "success",  "Aprobado"],
      rejected: ["fas fa-times",            "danger",   "Rechazado"]
    }[state] || ["fas fa-circle", "secondary", "No iniciado"];

    return (
      <Badge color={cfg[1]}>
        <i className={cfg[0]} title={cfg[2]} />
      </Badge>
    );
  };

  return (
    <>
      <div className="my-2 my-lg-0">
        <small className="fw-bold">Etapas del candidato</small>
        <ul className="fa-ul list-unstyled ms-1 small text-muted">
          <li>
            {icon(postulationState)}
            Postulación&nbsp;
            <small className="text-muted">
              <Moment format="DD/MM/YYYY HH:mm">{postulatedAt}</Moment>
            </small>
          </li>

          {orderedStages.map((st, i) => (
            <li key={i}>
              {icon(st.aasm_state)}{" "}
              <a
                style={{ cursor: "pointer", color: "#006f5c" }}
                onClick={() => setOpenStage(st)}
              >
                {st.name || "Sin nombre"}
              </a><DocsIcon stage={st} />{" "}
              {st.created_at && (
                <small className="text-muted">
                  <Moment format="DD/MM/YYYY HH:mm">{st.created_at}</Moment>
                </small>
              )}
            </li>
          ))}
        </ul>
      </div>

      {openStage && (
        <StageDetailsModal
          stage={openStage}
          toggle={() => setOpenStage(null)}
        />
      )}
    </>
  );
};

export default StageTimeline;
